define([
    "jquery",
    "underscore",
    "backbone",
    ], function($, _, Backbone) {
        "use strict";

        var ProductModel = Backbone.NestedModel.extend({
            initialize: function() {},
        });

        return ProductModel;

    });
